import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Constants} from '../constants/constants';
import {Observable} from 'rxjs';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  constructor(private http: HttpClient, private constants: Constants) {
  }

  get(url: string): Observable<any> {
    return this.http.get(`${this.constants.API_REST}${url}`);
  }

  post(url: string, body: any): Observable<any> {
    return this.http.post(`${this.constants.API_REST}${url}`, body, {headers: headers});
  }

  put(url: string, body: any): Observable<any> {
    return this.http.put(`${this.constants.API_REST}${url}`, body, {headers: headers});
  }

  delete(url: string): Observable<any> {
    return this.http.delete(`${this.constants.API_REST}${url}`);
  }

  getText(url: string): Observable<any> {
    return this.http.get(`${this.constants.API_REST}${url}`, {headers: headers, responseType: 'text', observe: 'response'});
  }

  putText(url: string, body: any): Observable<any> {
    return this.http.put(`${this.constants.API_REST}${url}`, body, {headers: headers, responseType: 'text', observe: 'response'});
  }

  getArpdf(url: string): Observable<any> {
    return this.http.get(`${this.constants.API_REST}${url}`, {responseType: 'arraybuffer'});
  }
}
